import React from 'react';
import CompetitionForm from 'src/components/CompetitionForm';
import {
    FilteredCollection,
    FilteredElement,
    Sport,
    Sports
} from 'src/domains/sportsbook/trading/view/Liabilities/LiabilitiesFilters/LiabilitiesFilters.types';
import { CompetitionItemViewType } from 'src_common/common/websocket2/models/EventsCollectionQueryModel';

// @TODO: allow few values to be expanded at once
// @TODO: Remove this function after @CompetitionForm refactor
const flatFromImmutable = (data: FilteredElement): FilteredElement => {
    const result = {};
    const keys = Object.keys(data);
    keys.forEach(key => {
        // @ts-expect-error remove when immutable gone from @CompetitionForm refactor
        const value = data[key];
        const splitKey = key.split('.');

        if (splitKey.length === 1) {
            // @ts-expect-error remove when immutable gone from @CompetitionForm refactor
            result[splitKey[0]] = value;
        } else {
            // @ts-expect-error remove when immutable gone from @CompetitionForm refactor
            result[splitKey[0]] = {
                // @ts-expect-error remove when immutable gone from @CompetitionForm refactor
                [splitKey[1]]: value
            };
        }
    });

    // @ts-expect-error remove when immutable gone from @CompetitionForm refactor
    return result;
};

export const buildFormCallback =
    (props: { sports: Immutable.List<Sport> }) =>
        (
            callback: (d: FilteredElement) => void,
            data: FilteredElement
        ): JSX.Element =>
            (
                <CompetitionForm
                    data={data.value}
                    onSubmit={(d: FilteredElement): void => callback(flatFromImmutable(d))}
                    {...props}
                />
            );

export const getFilters = (
    data: Sports | Array<CompetitionItemViewType>
): FilteredCollection => {
    if (data === undefined || data === null) {
        return [];
    }

    return data.map((x) => ({
        id: x.id,
        label: x.name,
        value: x
    }));
};
